import { print } from 'graphql'
import gql from 'graphql-tag'

import axiosql from '../axiosql'

function load() {
    return axiosql('user/graphql', {
        query: print(gql`
            {
                user {
                    _id
                    email
                    registrationDate
                    lastLogin
                    last2ndLogin
                    lastAuthenticated
                    upload
                    download
                    timeUsed
                    latestHandshake
                    enabled
                    balance
                    credit
                    lastBilled
                    planName
                    accessLevel
                    bill
                    staticBill
                    timeBill
                    dataBill
                    autoRenew
                    connected
                    referralCode
                    plan {
                        name
                        nickname
                        billingInterval
                        billingAmount
                        billingAmountPerGB
                        billingAmountPerHour
                        dataCap
                        timeCap
                    }
                }
            }
        `)
    })
}

function save(user) {
    return axiosql('user/graphql', {
        query: print(gql`
            mutation saveUser($password: String, $autoRenew: Boolean) {
                modifyUser(
                    data: {
                        password: $password
                        autoRenew: $autoRenew
                    }
                ) {
                    _id
                }
            }
        `),
        variables: {
            password: user.password,
            autoRenew: user.autoRenew
        }
    })
}

function settleBill(newPlanName) {
    return axiosql('user/graphql', {
        query: print(gql`
            mutation settleBill($newPlanName: String) {
                settleBill(
                    newPlanName: $newPlanName
                ) {
                    _id
                }
            }
        `),
        variables: {
            newPlanName
        }
    })
}

export { load, save, settleBill }
